var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleSelectionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 929",
    d: "M7.307 16.895l-4.028-4.029a.95.95 0 011.342-1.343l4.7 4.7-.671.671a.95.95 0 01-1.343 0zm4.1-.058l-3.984-3.949a.914.914 0 010-1.309.963.963 0 011.337 0l3.311 3.276 7.3-7.163a.956.956 0 011.33 0 .908.908 0 010 1.344l-7.966 7.8a.956.956 0 01-1.33 0zm-.575-4.858l4.7-4.7a.95.95 0 111.347 1.342l-4.7 4.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20689",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgMultipleSelectionIcon;